"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "signatureUrl": "https://oauth01-pro-testnet.arcana.network/oauth",
    "gatewayUrl": "https://gateway-testnet.arcana.network"
};
